export default "__VITE_ASSET__BvDsAZSq__"